"use strict";

exports.__esModule = true;
exports.uploadFile = uploadFile;
exports.uploadFileV2 = uploadFileV2;
exports.uploadFileToWixMedia = exports.uploadFileToWixMediaAction = void 0;

var _lodash = require("lodash");

var blobUtil = _interopRequireWildcard(require("blob-util"));

var _mediaTypes = require("./media-types");

var _requestUrl = require("./request-url");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DEFAULT_ENCODING_OPTIONS = {
  encoding_options: {
    file_output: {
      video: {
        format: ['mp4', 'webm']
      },
      audio: {
        format: 'm4a'
      }
    }
  }
};
var IMAGE_PROPERTIES = ['width', 'height', 'file_name', 'original_file_name'];

var uploadFileToWixMediaAction = function uploadFileToWixMediaAction(file) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;
    return (0, _requestUrl.requestFileUploadUrl)(request, file.name, file.type).then(function (_ref2) {
      var credentials = _ref2.credentials,
          _ref2$metadata = _ref2.metadata,
          acl = _ref2$metadata.acl,
          path = _ref2$metadata.path;
      return uploadFileV2({
        file: file,
        credentials: credentials,
        name: file.name,
        acl: acl,
        path: path
      });
    });
  };
};

exports.uploadFileToWixMediaAction = uploadFileToWixMediaAction;

var uploadFileToWixMedia = function uploadFileToWixMedia(requestFileUrl) {
  return function (file) {
    return requestFileUrl(file.name, file.type).then(function (_ref3) {
      var credentials = _ref3.credentials,
          _ref3$metadata = _ref3.metadata,
          acl = _ref3$metadata.acl,
          path = _ref3$metadata.path;
      return uploadFileV2({
        file: file,
        credentials: credentials,
        name: file.name,
        acl: acl,
        path: path
      });
    });
  };
};

exports.uploadFileToWixMedia = uploadFileToWixMedia;

function uploadFile(_ref4) {
  var file = _ref4.file,
      name = _ref4.name,
      type = _ref4.type,
      _ref4$credentials = _ref4.credentials,
      uploadToken = _ref4$credentials.uploadToken,
      uploadUrl = _ref4$credentials.uploadUrl,
      folderId = _ref4.folderId;
  var formData = new FormData();
  var blob = file;

  try {
    blob = blobUtil.dataURLToBlob(blob);
  } catch (e) {}

  formData.append('file', blob, name);
  formData.append('upload_token', uploadToken);
  formData.append('parent_folder_id', folderId);
  formData.append('media_type', type);

  if (type === _mediaTypes.TYPE_VIDEO) {
    (0, _lodash.forEach)(DEFAULT_ENCODING_OPTIONS, function (value, key) {
      return formData.append(key, value);
    });
  }

  var request = new XMLHttpRequest();
  var promise = new Promise(function (resolve, reject) {
    try {
      request.responseType = 'json'; // IE11 does not support responseType json
    } catch (error) {}

    request.addEventListener('load', function (event) {
      var data = event.target.response[0];

      try {
        data = JSON.parse(event.target.response)[0];
      } catch (error) {}

      if (type === _mediaTypes.TYPE_IMAGE) {
        data = (0, _lodash.pick)(data, IMAGE_PROPERTIES);
      }

      resolve(data);
    });
    request.addEventListener('error', reject);
    request.open('POST', uploadUrl);
    request.send(formData);
  });
  return {
    xhr: request,
    promise: promise
  };
}

function uploadFileV2(_ref5) {
  var file = _ref5.file,
      name = _ref5.name,
      path = _ref5.path,
      acl = _ref5.acl,
      _ref5$credentials = _ref5.credentials,
      token = _ref5$credentials.token,
      url = _ref5$credentials.url;
  var formData = new FormData();
  var blob = file;

  try {
    blob = blobUtil.dataURLToBlob(blob);
  } catch (e) {}

  formData.append('file', blob, name);
  formData.append('uploadToken', token);
  formData.append('acl', acl);
  formData.append('path', path);
  var request = new XMLHttpRequest();
  var promise = new Promise(function (resolve, reject) {
    try {
      request.responseType = 'json'; // IE11 does not support responseType json
    } catch (error) {}

    request.addEventListener('load', function (event) {
      var data = (0, _lodash.get)(event, 'target.response.payload.0');
      resolve(data);
    });
    request.addEventListener('error', reject);
    request.open('POST', url);
    request.send(formData);
  });
  return promise;
}